import { z } from "zod";
import { SCAWalletSchema } from "../treezor/index.js";

export default {
  params: z.object({}),
  response: z.object({
    scaWallets: z.array(
      SCAWalletSchema.pick({ id: true, creationDate: true }).extend({
        provider: z.string().nullable(),
      }),
    ),
  }),
};
